import { render, staticRenderFns } from "./LabelControl.vue?vue&type=template&id=4599ae19"
import script from "./LabelControl.vue?vue&type=script&lang=js"
export * from "./LabelControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports